<template>
  <div class="h-100 position-relative" v-if="hasMeterService">
    <div class="dashboard-card-wrap">
      <div class="dashboard-card-header">
        <div class="dashboard-card-header-left">
          {{ fd.name }}
          <a-icon class="ml-2" type="loading" v-if="loading" />
        </div>
        <div class="dashboard-card-header-right">
          <slot name="actions" :handle-edit="() => visible = true" />
          <router-link v-if="!edit" to="/iam/suggestsysalert" class="ml-2">
            <icon type="arrow-right" style="font-size:18px" />
          </router-link>
        </div>
      </div>
      <div class="dashboard-card-body align-items-center justify-content-center">
        <e-chart :options="chartOptions" style="height: 100%; width: 100%;" autoresize />
      </div>
    </div>
    <base-drawer :visible.sync="visible" :title="$t('dashboard.text_5')" @ok="handleSubmit">
      <a-form-model
        ref="form"
        hideRequiredMark
        :model="fd"
        :rules="rules">
        <a-form-model-item :label="$t('dashboard.text_6')" prop="name">
          <a-input v-model="fd.name" />
        </a-form-model-item>
      </a-form-model>
    </base-drawer>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters, mapState } from 'vuex'
import BaseDrawer from '@Dashboard/components/BaseDrawer'
import { load } from '@Dashboard/utils/cache'
import { getRequestT } from '@/utils/utils'
import { chartColors } from '@/constants'
import { numerify } from '@/filters'
// import { getCurrency } from '@/utils/common/cookie'
// import { currencyUnitMap } from '@/constants/currency'

export default {
  name: 'SuggestsysAlertsDetail',
  components: {
    BaseDrawer,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
    params: Object,
    edit: Boolean,
  },
  data () {
    const initNameValue = (this.params && this.params.name) || this.$t('dashboard.text_47')
    return {
      data: [],
      visible: false,
      loading: false,
      fd: {
        name: initNameValue,
      },
      rules: {
        name: [
          { required: true, message: this.$t('dashboard.text_8') },
        ],
      },
    }
  },
  computed: {
    ...mapState('common', {
      currency: state => state.bill.currency,
      currencyOpts: state => state.bill.currencyOpts,
    }),
    ...mapGetters(['scope', 'userInfo']),
    allData () {
      const arr = this.data.filter(item => item.cost_type === 'all')
      return arr[0] || {}
    },
    allCount () {
      return this.data.reduce((total, item) => total + item.count, 0)
    },
    currencyParams () {
      const { currency } = this.fd
      if (currency) {
        const params = {
          exchanged_currency: currency.replace('_', '').replace('*', ''),
          filter: [`currency.equals("${currency}")`],
        }
        if (currency.indexOf('_') !== -1) {
          params.filter = ''
        } else {
          params.exchanged_currency = ''
        }
        params.disable_cost_conversion = currency.indexOf('*') !== -1
        return params
      }
      return {}
    },
    outherData () {
      return this.data.map(item => {
        const ret = {
          ...item,
          // formatted_amount: numerify(item.amount, '0,0.00'),
          percent: this.getPercent(item.count, this.allCount),
          value: item.count,
        }
        ret.name = this.$te(`suggestsySuggestion.${ret.type}`) ? this.$t(`suggestsySuggestion.${ret.type}`) : ret.type
        return ret
      })
    },
    chartOptions () {
      return {
        title: [
          {
            text: this.$t('bill.resource_count'),
            subtext: this.allCount,
            textStyle: {
              fontSize: 12,
              color: '#ccc',
            },
            subtextStyle: {
              fontSize: 18,
              color: 'rgb(100, 100, 100)',
            },
            top: '42%',
            left: '24.5%',
            textAlign: 'center',
          },
        ],
        color: chartColors,
        legend: {
          type: 'scroll',
          pageIconSize: 8,
          icon: 'circle',
          orient: 'vertical',
          left: '50%',
          align: 'left',
          top: 'middle',
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            rich: {
              name: {
                verticalAlign: 'right',
                align: 'left',
                fontSize: 12,
                color: 'rgb(100, 100, 100)',
                height: 20,
              },
              percent: {
                align: 'left',
                color: chartColors[0],
                borderWidth: 1,
                borderColor: chartColors[0],
                padding: [3, 5, 3, 5],
              },
              value: {
                align: 'left',
                fontSize: 12,
                color: 'rgb(150, 150, 150)',
                padidng: 0,
              },
            },
          },
          height: '90%',
          formatter: name => {
            const item = R.find(R.propEq('name', name))(this.outherData)
            if (item) {
              return `{name|${name}}\n{value|${item.value}}  {percent|${item.percent}%}`
            }
            return name
          },
        },
        series: [
          {
            type: 'pie',
            center: ['25%', '50%'],
            radius: ['50%', '65%'],
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: this.outherData,
          },
        ],
      }
    },
    hasMeterService () { // 是否有计费的服务
      const { services } = this.userInfo
      const meterService = services.find(val => val.type === 'meter')
      if (meterService && meterService.status === true) {
        return true
      }
      return false
    },
  },
  created () {
    this.fetchData()
    this.$emit('update', this.options.i, {
      ...this.fd,
    })
  },
  methods: {
    refresh () {
      return this.fetchData()
    },
    async fetchData () {
      if (!this.hasMeterService) {
        return
      }
      this.loading = true
      try {
        const data = await load({
          res: 'quotas',
          actionArgs: {
            url: '/v1/suggestsysalerts/security',
            method: 'GET',
            params: {
              $t: getRequestT(),
              details: true,
              scope: this.scope,
              ...this.currencyParams,
            },
          },
          useManager: false,
          resPath: 'data',
        })
        this.data = data || []
        this.data.sort(this.compareData)
      } finally {
        this.loading = false
      }
    },
    async handleSubmit () {
      try {
        await this.$refs.form.validate()
        this.$emit('update', this.options.i, this.fd)
        this.visible = false
      } catch (error) {
        throw error
      }
    },
    getPercent (num, den) {
      const percent = (num / den) * 100
      if (percent && percent < 10) {
        return percent.toFixed(1)
      }
      return `${numerify(percent, 'percent')}`
    },
    compareData (a, b) {
      if (a.count > b.count) {
        return -1
      } else if (a.count < b.count) {
        return 1
      } else {
        return 0
      }
    },
  },
}
</script>
